/* eslint-disable  */

import { gql } from "@apollo/client";

// Role Management

export const CREATE_ROLE = gql`
  mutation CreateRole($input: CreateRoleInput!) {
    createRole(input: $input) {
      message
      status
    }
  }
`;

export const UPDATE_ROLE = gql`
  mutation UpdateRole($where: RoleWhereUpdateInput!, $input: UpdateRoleInput!) {
    updateRole(where: $where, input: $input) {
      message
      status
    }
  }
`;

export const DELETE_ROLE = gql`
  mutation DeleteRole($where: RoleWhereUpdateInput!) {
    deleteRole(where: $where) {
      message
      status
    }
  }
`;

// Admin Management

export const CREATE_ADMIN = gql`
  mutation CreateAdmin($input: CreateAdminInput!) {
    createAdmin(input: $input) {
      message
      status
    }
  }
`;

export const EDIT_ADMIN = gql`
  mutation UpdateAdmin(
    $where: AdminWhereUpdateInput!
    $input: UpdateAdminInput!
  ) {
    updateAdmin(where: $where, input: $input) {
      message
      status
    }
  }
`;
export const DELETE_ADMIN = gql`
  mutation DeleteAdmin($where: AdminWhereUpdateInput!) {
    deleteAdmin(where: $where) {
      message
      status
    }
  }
`;
export const DISABLE_ADMIN = gql`
  mutation DisableAdmin($input: disableAdminInput!) {
    disableAdmin(input: $input) {
      message
      status
    }
  }
`;

export const UPDATE_PASSWORD = gql`
  mutation UpdatePassword($input: UpdatePasswordInput!) {
    updatePassword(input: $input) {
      message
      status
      referenceCode
      mobile
      countryCode
    }
  }
`;
export const UPDATE_NUMBER = gql`
  mutation UpdateMobile($input: UpdateMobileInput!) {
    updateMobile(input: $input) {
      message
      referenceCode
      status
      mobile
      countryCode
    }
  }
`;

// Category Management

export const CREATE_CATEGORY = gql`
  mutation CreateCategory($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      message
      status
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory(
    $where: CategoryWhereUniqueInput!
    $input: UpdateCategoryInput!
  ) {
    updateCategory(where: $where, input: $input) {
      message
      status
    }
  }
`;

export const DELETE_CATEGORY = gql`
  mutation DeleteCategory($input: CategoryWhereUniqueInput) {
    deleteCategory(input: $input) {
      message
      status
    }
  }
`;

// Platform Variables

export const UPDATE_VARIABLE = gql`
  mutation UpdateVariable(
    $input: UpdateVariableInput!
    $where: VariableWhereUpdateInput!
  ) {
    updateVariable(input: $input, where: $where) {
      message
      status
    }
  }
`;

export const UPDATE_FEATURED_COLLECTION = gql`
  mutation FeaturedCollection($input: CollectionFeaturedInput!) {
    featuredCollection(input: $input) {
      message
      status
    }
  }
`;

// Import collection

export const APPROVE_IMPORT_COLLECTION_REQUEST = gql`
  mutation ImportCollection($input: ImportCollectionInput!) {
    importCollection(input: $input) {
      message
      status
    }
  }
`;
export const REJECT_IMPORT_COLLECTION_REQUEST = gql`
  mutation UpdateForm($where: FormWhereUniqueInput!, $input: UpdateFormInput!) {
    updateForm(where: $where, input: $input) {
      message
      status
    }
  }
`;

// CMS
export const CREATE_CMS = gql`
  mutation CreateCms($input: CreateCmsInput!) {
    createCms(input: $input) {
      message
      status
    }
  }
`;

export const UPDATE_CMS = gql`
  mutation UpdateCms($updateCmsId: ID!, $input: UpdateCmsInput!) {
    updateCms(id: $updateCmsId, input: $input) {
      message
      status
    }
  }
`;

export const DELETE_CMS = gql`
  mutation DeleteCms($deleteCmsId: ID!) {
    deleteCms(id: $deleteCmsId) {
      message
      status
    }
  }
`;


export const GRAPH_MUTATION = gql`
  mutation Graph($input: graphInput!) {
    graph(input: $input) {
      message
      status
      graphdata {
        chainNumber
        arrMonth {
          data1 {
            value
            datetime
          }
          data2 {
            value
            datetime
          }
          data3 {
            value
            datetime
          }
          data4 {
            value
            datetime
          }
          data5 {
            value
            datetime
          }
          data6 {
            value
            datetime
          }
          data7 {
            value
            datetime
          }
          data8 {
            value
            datetime
          }
          data9 {
            value
            datetime
          }
          data10 {
            value
            datetime
          }
          data11 {
            value
            datetime
          }
          data12 {
            value
            datetime
          }
          data13 {
            value
            datetime
          }
          data14 {
            value
            datetime
          }
          data15 {
            value
            datetime
          }
          data16 {
            value
            datetime
          }
          data17 {
            value
            datetime
          }
          data18 {
            value
            datetime
          }
          data19 {
            value
            datetime
          }
          data20 {
            value
            datetime
          }
          data21 {
            value
            datetime
          }
          data22 {
            value
            datetime
          }
          data23 {
            value
            datetime
          }
          data24 {
            value
            datetime
          }
          data25 {
            value
            datetime
          }
          data26 {
            value
            datetime
          }
          data27 {
            value
            datetime
          }
          data28 {
            value
            datetime
          }
          data29 {
            value
            datetime
          }
          data30 {
            value
            datetime
          }
          data31 {
            value
            datetime
          }
        }
      }
    }
  }
`;

export const PROJECT_GRAPH_MUTATION = gql`
  mutation ProjectGraph($input: graphInput!) {
  projectGraph(input: $input) {
    type
    message
    status
    graphdata {
      chainNumber
      arrMonth {
        data1 {
          value
          datetime
        }
        data2 {
          value
          datetime
        }
        data3 {
          value
          datetime
        }
        data4 {
          value
          datetime
        }
        data5 {
          value
          datetime
        }
        data6 {
          value
          datetime
        }
        data7 {
          value
          datetime
        }
        data8 {
          value
          datetime
        }
        data9 {
          value
          datetime
        }
        data10 {
          value
          datetime
        }
        data11 {
          value
          datetime
        }
        data12 {
          value
          datetime
        }
        data13 {
          value
          datetime
        }
        data14 {
          value
          datetime
        }
        data15 {
          value
          datetime
        }
        data16 {
          value
          datetime
        }
        data17 {
          value
          datetime
        }
        data18 {
          value
          datetime
        }
        data19 {
          value
          datetime
        }
        data20 {
          value
          datetime
        }
        data21 {
          value
          datetime
        }
        data22 {
          value
          datetime
        }
        data23 {
          value
          datetime
        }
        data24 {
          value
          datetime
        }
        data25 {
          value
          datetime
        }
        data26 {
          value
          datetime
        }
        data27 {
          value
          datetime
        }
        data28 {
          value
          datetime
        }
        data29 {
          value
          datetime
        }
        data30 {
          value
          datetime
        }
        data31 {
          value
          datetime
        }
      }
    }
  }
}
`;

export const SUBS_GRAPH_MUTATION = gql`
  mutation SubsGraph($input: graphInput!) {
    subsGraph(input: $input) {
      type
      message
      status
      graphdata {
        chainNumber
        arrMonth {
          data1 {
            value
            datetime
          }
          data2 {
            value
            datetime
          }
        data3 {
          value
          datetime
        }
        data4 {
          value
          datetime
        }
        data5 {
          value
          datetime
        }
        data6 {
          value
          datetime
        }
        data7 {
          value
          datetime
        }
        data8 {
          value
          datetime
        }
        data9 {
          value
          datetime
        }
        data10 {
          value
          datetime
        }
        data11 {
          value
          datetime
        }
        data12 {
          value
          datetime
        }
        data13 {
          value
          datetime
        }
        data14 {
          value
          datetime
        }
        data15 {
          value
          datetime
        }
        data16 {
          value
          datetime
        }
        data17 {
          value
          datetime
        }
        data18 {
          value
          datetime
        }
        data19 {
          value
          datetime
        }
        data20 {
          value
          datetime
        }
        data21 {
          value
          datetime
        }
        data22 {
          value
          datetime
        }
        data23 {
          value
          datetime
        }
        data24 {
          value
          datetime
        }
        data25 {
          value
          datetime
        }
        data26 {
          value
          datetime
        }
        data27 {
          value
          datetime
        }
        data28 {
          value
          datetime
        }
        data29 {
          value
          datetime
        }
        data30 {
          value
          datetime
        }
        data31 {
          value
          datetime
        }
      }
    }
  }
}
`;

export const USER_GRAPH_MUTATION = gql`
 mutation UserGraph($input: graphInput!) {
  userGraph(input: $input) {
    type
    message
    status
    graphdata {
      chainNumber
      arrMonth {
        data1 {
          value
          datetime
        }
        data2 {
          value
          datetime
        }
        data3 {
          value
          datetime
        }
        data4 {
          value
          datetime
        }
        data5 {
          value
          datetime
        }
        data6 {
          value
          datetime
        }
        data7 {
          value
          datetime
        }
        data8 {
          value
          datetime
        }
        data9 {
          value
          datetime
        }
        data10 {
          value
          datetime
        }
        data11 {
          value
          datetime
        }
        data12 {
          value
          datetime
        }
        data13 {
          value
          datetime
        }
        data14 {
          value
          datetime
        }
        data15 {
          value
          datetime
        }
        data16 {
          value
          datetime
        }
        data17 {
          value
          datetime
        }
        data18 {
          value
          datetime
        }
        data19 {
          value
          datetime
        }
        data20 {
          value
          datetime
        }
        data21 {
          value
          datetime
        }
        data22 {
          value
          datetime
        }
        data23 {
          value
          datetime
        }
        data24 {
          value
          datetime
        }
        data25 {
          value
          datetime
        }
        data26 {
          value
          datetime
        }
        data27 {
          value
          datetime
        }
        data28 {
          value
          datetime
        }
        data29 {
          value
          datetime
        }
        data30 {
          value
          datetime
        }
        data31 {
          value
          datetime
        }
      }
    }
  }
}
`;

export const STORAGE_GRAPH_MUTATION = gql`
  mutation UserGraph($input: graphInput!) {
  userGraph(input: $input) {
    type
    message
    status
    graphdata {
      chainNumber
      arrMonth {
        data1 {
          value
          datetime
        }
        data2 {
          value
          datetime
        }
        data3 {
          value
          datetime
        }
        data4 {
          value
          datetime
        }
        data5 {
          value
          datetime
        }
        data6 {
          value
          datetime
        }
        data7 {
          value
          datetime
        }
        data8 {
          value
          datetime
        }
        data9 {
          value
          datetime
        }
        data10 {
          value
          datetime
        }
        data11 {
          value
          datetime
        }
        data12 {
          value
          datetime
        }
        data13 {
          value
          datetime
        }
        data14 {
          value
          datetime
        }
        data15 {
          value
          datetime
        }
        data16 {
          value
          datetime
        }
        data17 {
          value
          datetime
        }
        data18 {
          value
          datetime
        }
        data19 {
          value
          datetime
        }
        data20 {
          value
          datetime
        }
        data21 {
          value
          datetime
        }
        data22 {
          value
          datetime
        }
        data23 {
          value
          datetime
        }
        data24 {
          value
          datetime
        }
        data25 {
          value
          datetime
        }
        data26 {
          value
          datetime
        }
        data27 {
          value
          datetime
        }
        data28 {
          value
          datetime
        }
        data29 {
          value
          datetime
        }
        data30 {
          value
          datetime
        }
        data31 {
          value
          datetime
        }
      }
    }
  }
}
`;

export const TRACK_GRAPH_MUTATION = gql`
   mutation TrackGraph($input: graphInput!) {
  trackGraph(input: $input) {
    type
    message
    status
    graphdata {
      chainNumber
      arrMonth {
        data1 {
          value
          datetime
        }
        data2 {
          value
          datetime
        }
        data3 {
          value
          datetime
        }
        data4 {
          value
          datetime
        }
        data5 {
          value
          datetime
        }
        data6 {
          value
          datetime
        }
        data7 {
          value
          datetime
        }
        data8 {
          value
          datetime
        }
        data9 {
          value
          datetime
        }
        data10 {
          value
          datetime
        }
        data11 {
          value
          datetime
        }
        data12 {
          value
          datetime
        }
        data13 {
          value
          datetime
        }
        data14 {
          value
          datetime
        }
        data15 {
          value
          datetime
        }
        data16 {
          value
          datetime
        }
        data17 {
          value
          datetime
        }
        data18 {
          value
          datetime
        }
        data19 {
          value
          datetime
        }
        data20 {
          value
          datetime
        }
        data21 {
          value
          datetime
        }
        data22 {
          value
          datetime
        }
        data23 {
          value
          datetime
        }
        data24 {
          value
          datetime
        }
        data25 {
          value
          datetime
        }
        data26 {
          value
          datetime
        }
        data27 {
          value
          datetime
        }
        data28 {
          value
          datetime
        }
        data29 {
          value
          datetime
        }
        data30 {
          value
          datetime
        }
        data31 {
          value
          datetime
        }
      }
    }
  }
}
`;

export const CREATE_SUBSCRIPTION_PLAN = gql`
  mutation CreateSubscription($input: CreateSubscriptionInput!) {
    createSubscription(input: $input) {
      status
      message
      subscription {
        id
        coinflowPlanId
        name
        planCode
        description
        type
        price
        interval
        duration
        currency
        features {
          featureKey
          description
          not_available_description
          available
          limit
          unit
        }
        status
        createdById
        updatedById
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_SUBSCRIPTION_PLAN = gql`
  mutation UpdateSubscription(
    $where: SubscriptionWhereUpdateInput!
    $input: UpdateSubscriptionInput!
  ) {
    updateSubscription(where: $where, input: $input) {
      status
      message
      subscription {
        id
        coinflowPlanId
        name
        planCode
        description
        type
        price
        interval
        duration
        currency
        features {
          featureKey
          description
          not_available_description
          available
          limit
          unit
        }
        status
        createdById
        updatedById
        createdAt
        updatedAt
      }
    }
  }
`;

export const DELETE_SUBSCRIPTION_PLAN = gql`
  mutation DeleteSubscription($where: SubscriptionWhereUpdateInput!) {
    deleteSubscription(where: $where) {
      status
      message
    }
  }
`;

export const UPDATE_GAMIFICATION_EVENT = gql`
  mutation UpdateEvent(
    $where: GamificationWhereUpdateInput!
    $input: GamificationUpdateInput!
  ) {
    updateEvent(where: $where, input: $input) {
      message
      status
    }
  }
`;

export const UPDATE_GAMIFICATION_STATUS = gql`
  mutation UpdateStatus(
    $where: GamificationWhereUpdateInput!
    $input: GamificationStatusInput!
  ) {
    updateStatus(where: $where, input: $input) {
      message
      status
    }
  }
`;

export const CREATE_QUEST = gql`
  mutation CreateQuest($input: CreateQuestInput!) {
    createQuest(input: $input) {
      message
      status
    }
  }
`;
export const UPDATE_QUEST = gql`
  mutation UpdateQuest(
    $input: QuestUpdateInput!
    $where: QuestWhereUpdateInput!
  ) {
    updateQuest(input: $input, where: $where) {
      message
      status
    }
  }
`;

export const UPDATE_QUEST_STATUS = gql`
  mutation QuestStatus(
    $where: QuestWhereUpdateInput!
    $input: QuestStatusInput!
  ) {
    questStatus(where: $where, input: $input) {
      message
      status
    }
  }
`;

export const CREATE_AIRDROP = gql`
  mutation CreateAirdrop($input: CreateAirdropInput!) {
    createAirdrop(input: $input) {
      message
      status
    }
  }
`;

export const CANCEL_AIRDROP = gql`
  mutation CancelAirdrop($input: CancelAirdropInput!) {
    cancelAirdrop(input: $input) {
      message
      status
    }
  }
`;

export const CHANGE_CONTENT_REQUEST_STATUS = gql`
 mutation NftStatus($where: NftWhereUpdateInput!, $input: UpdateStatusInput!) {
  nftStatus(where: $where, input: $input) {
    message
    status
  }
}
`;

export const CREATE_FORUM = gql`
  mutation CreateForum($input: CreateForumInput!) {
    createForum(input: $input) {
      message
      status
    }
  }
`;

export const UPDATE_FORUM = gql`
  mutation ForumUpdate($where: ForumWhereUpdateInput!, $input: UpdateForumInput!) {
    forumUpdate(where: $where, input: $input) {
      message
      status
    }
  }
`;

export const DELETE_FORUM = gql`
  mutation DeleteForum($where: ForumWhereUpdateInput!, $input: DeleteForumInput!) {
  deleteForum(where: $where, input: $input) {
    message
    status
  }
}
`;

export const POST_STATUS = gql`
  mutation PostStatus($where: PostWhereUpdateInput!, $input: UpdateInput!) {
    postStatus(where: $where, input: $input) {
      message
      status
    }
  }
`;

export const CREATE_CSV_LEAD = gql`
  mutation CreateCsvLead($input: CreateCsvLeadInput!) {
    createCsvLead(input: $input) {
      message
      status
    }
  }
`;

export const CREATE_INVITE_USER = gql`
  mutation CreateInviteUser($input: CreateInviteUserInput!) {
    createInviteUser(input: $input) {
      message
      status
    }
  }
`;

export const BULK_INVITE_USER = gql`
  mutation BulkInviteUser($input: BulkInviteUserInput!) {
    bulkInviteUser(input: $input) {
      message
      status
      totalEmails
      validEmails
      invalidEmails
      successCount
      skippedCount
    }
  }
`;

export const REVOKE_INVITE_USER = gql`
  mutation RevokeInviteUser($input: RevokeInviteUserInput!) {
    revokeInviteUser(input: $input) {
      message
      status
    }
  }
`;

;

export const CREATE_MODASH_LEAD = gql`
  mutation CreateModashLead($input: CreateModashLeadInput!) {
    createModashLead(input: $input) {
      message
      status
      data {
        total
        pages
        platform
        payload
        data {
          userId
          profile {
            engagementRate
            engagements
            followers
            fullname
            url
            username
            isVerified
            isPrivate
            picture
          }
        }
      }
    }
  }
`;

;

export const CREATE_CLUSTER = gql`
  mutation CreateLeadList($input: CreateLeadListInput!) {
    createLeadList(input: $input) {
      message
      status
    }
  }
`;

;

export const DELETE_CLUSTER = gql`
  mutation DeleteLeadList($input: DeleteLeadListInput!) {
    deleteLeadList(input: $input) {
      message
      status
    }
  }
`;

;

export const ADD_LEADS_TO_CLUSTER = gql`
  mutation CreateInstantlyLead($input: AssignUsersToListInput!) {
    createInstantlyLead(input: $input) {
      message
      status
    }
  }
`;

export const DELETE_LEAD = gql`
mutation DeleteLead($input: DeleteLeadInput!) {
  deleteLead(input: $input) {
    message
    status
  }
}
`;

export const CREATE_CAMPAIGN = gql`
mutation CreateCampaign($input: CreateCampaignInput!) {
  createCampaign(input: $input) {
    message
    status
    data {
      id
    }
  }
}
`;

export const SET_TGE_TIMESTAMP = gql`
  mutation SetTgeTimestamp($input: SetTGEInput!) {
    setTGE(input: $input) {
      status
      message
      data
    }
  }
`;

export const CREATE_TOKEN_VESTING = gql`
  mutation CreateTokenVesting($input: CreateVestingInput!) {
    create(input: $input) {
      status
      message
      data
    }
  }
`;

export const MOVE_LEAD_TO_CAMPAIGN = gql`
  mutation MoveLeadToCampaign($input: MoveLeadToCampaignInput!) {
  moveLeadToCampaign(input: $input) {
    message
    status
  }
}
`;

export const UPDATE_CAMPAIGN = gql`
  mutation UpdateCampaign($where: CampaignsWhereUpdateInput!, $input: CampaignsUpdateInput!) {
  updateCampaign(where: $where, input: $input) {
    message
    status
  }
}
`;

export const START_CAMPAIGN = gql`
  mutation StartCampaign($input: StartCampaignInput!) {
    startCampaign(input: $input) {
      message
      status
    }
  }
`;

export const STOP_CAMPAIGN = gql`
  mutation StopCampaign($input: StartCampaignInput!) {
    stopCampaign(input: $input) {
      message
      status
    }
  }
`;

export const DELETE_CAMPAIGN = gql`
  mutation DeleteCampaign($where: CampaignsWhereUpdateInput!) {
    deleteCampaign(where: $where) {
      message
      status
    }
  }
`;

export const EXPORT_LEADS = gql`
  query ExportLead($filters: LeadWhereInput) {
  exportLead(filters: $filters) {
    message
    fileUrl
    status
  }
}
`;

export const CREATE_LEAD = gql`
  mutation CreateLead($input: CreateLeadInput!) {
    createLead(input: $input) {
      message
      status
    }
  }
`;

export const BULK_DELETE_LEAD = gql`
  mutation BulkDeleteLead($input: BulkDeleteLeadInput!) {
    bulkDeleteLead(input: $input) {
      message
      status
    }
  }
`;

export const DELETE_ALL_LEADS = gql`
  mutation AllDeleteLead {
    allDeleteLead {
      message
      status
    }
  }
`

export const CREATE_BULK_INSTANTLY_LEAD = gql`
  mutation CreateBulkInstantlyLead($input: CreateBulkInstantlyLeadInput!) {
    createBulkInstantlyLead(input: $input) {
      message
      status
    }
  }
`;


export const SEND_EMAIL_REPLY = gql`
  mutation SendEmailReply($input: SendEmailReplyInput!) {
    sendEmailReply(input: $input) {
      message
      status
      data {
        id
        timestamp_created
        timestamp_email
        message_id
        subject
        to_address_email_list
        body {
          text
          html
        }
        organization_id
        eaccount
        from_address_email
        campaign_id
        lead
        ue_type
        step
        is_unread
        is_focused
        thread_id
        content_preview
        from_address_json {
          address
          name
        }
        to_address_json {
          address
          name
        }
      }
    }
  }
`;

// Email Reply
export const REPLY = gql`
  mutation Reply($input: ReplyInput!) {
  reply(input: $input) {
    message
    status
  }
}
`;

export const REMINDER = gql`
  mutation Reminder($input: ReminderInput!) {
    reminder(input: $input) {
      message
      status
    }
  }
`;

// ICO Management
export const CREATE_ICO = gql`
  mutation CreateIco($input: CreateIcoInput!) {
    createIco(input: $input) {
      message
      status
    }
  }
`;

export const UPDATE_ICO_END_DATE = gql`
  mutation EndDate($input: EndDateIcoInput!) {
    endDate(input: $input) {
      message
      status
    }
  }
`;

export const FINALIZE_ICO = gql`
  mutation Finalize {
    finalize {
      message
      status
    }
  }
`;

export const TRANSFER_ICO_TOKEN = gql`
  mutation TransferToken($input: TransferTokenInput!) {
    transferToken(input: $input) {
      message
      status
    }
  }
`;

export const WITHDRAW_ICO_NATIVE = gql`
  mutation WithdrawNative($input: WithdrawNativeInput!) {
    withdrawNative(input: $input) {
      message
      status
    }
  }
`;

export const WITHDRAW_ICO_STABLE = gql`
  mutation WithdrawStable($input: WithdrawStableInput!) {
    withdrawStable(input: $input) {
      message
      status
    }
  }
`;

export const PAUSED = gql`
  mutation Paused {
    paused {
      status
      message
      data
    }
  }
`;

export const UNPAUSED = gql`
  mutation Unpaused {
    unpaused {
      status
      message
      data
    }
  }
`;

export const UPDATE_TOKEN_PER_POINT = gql`
  mutation UpdateTokenPerPoint($input: UpdateTokenPerPointInput!) {
    updateTokenPerPoint(input: $input) {
      status
      message
      data
    }
  }
`;

export const UPDATE_HARD_CAP = gql`
  mutation HardCap($input: HardCapIcoInput!) {
    hardCap(input: $input) {
      message
      status
    }
  }
`;

export const UPDATE_TOKEN_PRICE = gql`
  mutation UpdateTokenPrice($input: UpdateTokenPriceInput!) {
    updateTokenPrice(input: $input) {
      message
      status
    }
  }
`;

// ─── Camaroo Graph Mutations ─────────────────────────────────────────────────

export const CAMAROO_USER_GRAPH_MUTATION = gql`
  mutation UserGraph($input: graphInput!) {
    userGraph(input: $input) {
      type
      message
      status
      graphdata {
        chainNumber
        arrMonth {
          data1 { value datetime }
          data2 { value datetime }
          data3 { value datetime }
          data4 { value datetime }
          data5 { value datetime }
          data6 { value datetime }
          data7 { value datetime }
          data8 { value datetime }
          data9 { value datetime }
          data10 { value datetime }
          data11 { value datetime }
          data12 { value datetime }
          data13 { value datetime }
          data14 { value datetime }
          data15 { value datetime }
          data16 { value datetime }
          data17 { value datetime }
          data18 { value datetime }
          data19 { value datetime }
          data20 { value datetime }
          data21 { value datetime }
          data22 { value datetime }
          data23 { value datetime }
          data24 { value datetime }
          data25 { value datetime }
          data26 { value datetime }
          data27 { value datetime }
          data28 { value datetime }
          data29 { value datetime }
          data30 { value datetime }
          data31 { value datetime }
        }
      }
    }
  }
`;

export const PORTFOLIO_GRAPH_MUTATION = gql`
  mutation PortfolioGraph($input: graphInput!) {
    portfolioGraph(input: $input) {
      type
      message
      status
      graphdata {
        chainNumber
        arrMonth {
          data1 { value datetime }
          data2 { value datetime }
          data3 { value datetime }
          data4 { value datetime }
          data5 { value datetime }
          data6 { value datetime }
          data7 { value datetime }
          data8 { value datetime }
          data9 { value datetime }
          data10 { value datetime }
          data11 { value datetime }
          data12 { value datetime }
          data13 { value datetime }
          data14 { value datetime }
          data15 { value datetime }
          data16 { value datetime }
          data17 { value datetime }
          data18 { value datetime }
          data19 { value datetime }
          data20 { value datetime }
          data21 { value datetime }
          data22 { value datetime }
          data23 { value datetime }
          data24 { value datetime }
          data25 { value datetime }
          data26 { value datetime }
          data27 { value datetime }
          data28 { value datetime }
          data29 { value datetime }
          data30 { value datetime }
          data31 { value datetime }
        }
      }
    }
  }
`;

export const OPPORTUNITY_GRAPH_MUTATION = gql`
  mutation OpportunityGraph($input: graphInput!) {
    opportunityGraph(input: $input) {
      type
      message
      status
      graphdata {
        chainNumber
        arrMonth {
          data1 { value datetime }
          data2 { value datetime }
          data3 { value datetime }
          data4 { value datetime }
          data5 { value datetime }
          data6 { value datetime }
          data7 { value datetime }
          data8 { value datetime }
          data9 { value datetime }
          data10 { value datetime }
          data11 { value datetime }
          data12 { value datetime }
          data13 { value datetime }
          data14 { value datetime }
          data15 { value datetime }
          data16 { value datetime }
          data17 { value datetime }
          data18 { value datetime }
          data19 { value datetime }
          data20 { value datetime }
          data21 { value datetime }
          data22 { value datetime }
          data23 { value datetime }
          data24 { value datetime }
          data25 { value datetime }
          data26 { value datetime }
          data27 { value datetime }
          data28 { value datetime }
          data29 { value datetime }
          data30 { value datetime }
          data31 { value datetime }
        }
      }
    }
  }
`;

export const CAMAROO_SUBS_GRAPH_MUTATION = gql`
  mutation SubsGraph($input: graphInput!) {
    subsGraph(input: $input) {
      type
      message
      status
      graphdata {
        chainNumber
        arrMonth {
          data1 { value datetime }
          data2 { value datetime }
          data3 { value datetime }
          data4 { value datetime }
          data5 { value datetime }
          data6 { value datetime }
          data7 { value datetime }
          data8 { value datetime }
          data9 { value datetime }
          data10 { value datetime }
          data11 { value datetime }
          data12 { value datetime }
          data13 { value datetime }
          data14 { value datetime }
          data15 { value datetime }
          data16 { value datetime }
          data17 { value datetime }
          data18 { value datetime }
          data19 { value datetime }
          data20 { value datetime }
          data21 { value datetime }
          data22 { value datetime }
          data23 { value datetime }
          data24 { value datetime }
          data25 { value datetime }
          data26 { value datetime }
          data27 { value datetime }
          data28 { value datetime }
          data29 { value datetime }
          data30 { value datetime }
          data31 { value datetime }
        }
      }
    }
  }
`;

export const COURSE_PURCHASE_GRAPH_MUTATION = gql`
  mutation CoursePurchaseGraph($input: graphInput!) {
    coursePurchaseGraph(input: $input) {
      type
      message
      status
      graphdata {
        chainNumber
        arrMonth {
          data1 { value datetime }
          data2 { value datetime }
          data3 { value datetime }
          data4 { value datetime }
          data5 { value datetime }
          data6 { value datetime }
          data7 { value datetime }
          data8 { value datetime }
          data9 { value datetime }
          data10 { value datetime }
          data11 { value datetime }
          data12 { value datetime }
          data13 { value datetime }
          data14 { value datetime }
          data15 { value datetime }
          data16 { value datetime }
          data17 { value datetime }
          data18 { value datetime }
          data19 { value datetime }
          data20 { value datetime }
          data21 { value datetime }
          data22 { value datetime }
          data23 { value datetime }
          data24 { value datetime }
          data25 { value datetime }
          data26 { value datetime }
          data27 { value datetime }
          data28 { value datetime }
          data29 { value datetime }
          data30 { value datetime }
          data31 { value datetime }
        }
      }
    }
  }
`;

// Update Subscription Price
export const UPDATE_SUBSCRIPTION_PRICE = gql`
  mutation UpdateSubscriptionPrice(
    $where: SubscriptionWhereUniqueInput!
    $input: UpdateSubscriptionPriceInput!
  ) {
    updateSubscriptionPrice(where: $where, input: $input) {
      message
      status
    }
  }
`;

// ===================== Camaroo Courses =====================

export const CREATE_COURSE = gql`
  mutation CreateCourse($input: CreateCourseInput!) {
    createCourse(input: $input) {
      message
      status
    }
  }
`;

export const UPDATE_COURSE = gql`
  mutation UpdateCourse($input: UpdateCourseInput!) {
    updateCourse(input: $input) {
      message
      status
    }
  }
`;

export const START_COURSE_UPLOAD = gql`
  mutation StartCourseUpload($input: StartCourseUploadInput!) {
    startCourseUpload(input: $input) {
      message
      status
      uploadId
      key
      partCount
      fileSize
    }
  }
`;

export const GET_COURSE_UPLOAD_URLS = gql`
  mutation GetCourseUploadUrls($input: GetCourseUploadUrlsInput!) {
    getCourseUploadUrls(input: $input) {
      message
      status
      key
      uploadId
      partCount
      urls {
        partNumber
        signedUrl
      }
    }
  }
`;

export const COMPLETE_COURSE_UPLOAD = gql`
  mutation CompleteCourseUpload($input: CompleteCourseUploadInput!) {
    completeCourseUpload(input: $input) {
      message
      status
      key
      fileUrl
    }
  }
`;

export const APPEND_COURSE_VIDEO = gql`
  mutation AppendCourseVideo($input: AppendCourseVideoInput!) {
    appendCourseVideo(input: $input) {
      message
      status
    }
  }
`;

export const DELETE_COURSE_VIDEO = gql`
  mutation DeleteCourseVideo($input: DeleteCourseVideoInput!) {
    deleteCourseVideo(input: $input) {
      message
      status
    }
  }
`;

export const UPLOAD_COURSE_IMAGE = gql`
  mutation UploadCourseImage($input: UploadCourseImageInput!) {
    uploadCourseImage(input: $input) {
      message
      status
      uploadUrl
      key
      fileUrl
    }
  }
`;
